import { createReducer, on } from '@ngrx/store'
import { InitialConfigActions } from '../actions/initial-config.actions'
import { ExternalProviderEnum } from '../../../../login/external-provider/external-provider.enum'
import { LoginMethodEnum } from '../../../../login/shared/login-method-enum'

export const initialConfigFeatureKey = 'initialConfig'

export interface InitialConfigState {
  loaded: boolean
  config: InitialConfiguration | null
}

export interface ExternalClientInformation {
  externalClientName: string
  externalTermsPrivacyLinks: string[]
  externalInfoPage?: string
}

export interface InitialConfiguration {
  useTestRecaptcha: boolean
  externalAuthProviders: ExternalProviderEnum[]
  internalAuthMethods: LoginMethodEnum[]
  externalClientDetails: ExternalClientInformation
}

export const initialState: InitialConfigState = {
  loaded: false,
  config: {
    useTestRecaptcha: false,
    externalAuthProviders: [],
    internalAuthMethods: [],
    externalClientDetails: {
      externalClientName: null,
      externalTermsPrivacyLinks: [],
      externalInfoPage: null,
    },
  },
}

export const reducer = createReducer(
  initialState,
  on(InitialConfigActions.initialConfigLoaded, (state, { initialConfig }) => ({
    ...state,
    ...initialConfig,
    loaded: true,
  })),
  on(InitialConfigActions.initialConfigError, () => ({
    ...initialState,
    loaded: true,
  })),
)
